
import CookieSettings from "@/components/layout/CookieSettings"
import consentCookieMixin from "@/mixins/consentCookieMixin"
import Button from "@/components/base/Button"
import { routeToDatenschutz } from "@/helpers/routing"

export default {
    components: { Button, CookieSettings },
    mixins: [consentCookieMixin],
    data: () => ({
        routeToDatenschutz,
    }),
    methods: {
        showCookieSettings(show) {
            this.$store.dispatch("cookie/showCookieSettings", show)
        },
        accept() {
            this.$store.dispatch("cookie/setCookie", {
                performance: 1,
                marketing: 1,
                functional: 1,
            })
        },
    },
}
